module.exports = __webpack_public_path__ + "../resources/images/emptySearch_calendar-da82148c36b12ee0f5f040e1fe4889c6.svg";